export const getMinStartEndWorkDate = (): Date => {
  const date = new Date();
  date.setFullYear(1950, 1, 0);
  return date;
};
